"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/other-pages/pricing/pricing.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type BreadcrumbSectionGeneratedProps = {
    divDiv0Div0ClassName?: string;
    /** Default: "breadcrumb" */
    divDiv0Div0Div0Nav0NavAriaLabel?: string;
    /** Default: "Pricing Plan" */
    divDiv0Div0Div0Nav0H20H2Text?: ReactNode;
    divDiv0Div0Div0Nav0H20H2Visible?: boolean;
    divDiv0Div0Div0Nav0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Nav0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "all_routes.home" */
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkHref?: string;
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkVisible?: boolean;
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Pricing Plan" */
    divDiv0Div0Div0Nav0Ol0Li1LiText?: ReactNode;
    /** Default: "img" */
    divDiv1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/breadcrumb-bg-01.png" */
    divDiv1ImageWithBasePath0ImageSrc?: string;
    divDiv1ImageWithBasePath0ImageVisible?: boolean;
    divDiv1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    divDiv1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/breadcrumb-bg-02.png" */
    divDiv1ImageWithBasePath1ImageSrc?: string;
    divDiv1ImageWithBasePath1ImageVisible?: boolean;
    divDiv1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    divDiv1ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/breadcrumb-icon.png" */
    divDiv1ImageWithBasePath2ImageSrc?: string;
    divDiv1ImageWithBasePath2ImageVisible?: boolean;
    divDiv1ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "img" */
    divDiv1ImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/breadcrumb-icon.png" */
    divDiv1ImageWithBasePath3ImageSrc?: string;
    divDiv1ImageWithBasePath3ImageVisible?: boolean;
    divDiv1ImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1ImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const BreadcrumbSectionGenerated: FC<BreadcrumbSectionGeneratedProps> = ({
    divDiv0Div0Div0Nav0H20H2Text = "Pricing Plan",
    divDiv0Div0Div0Nav0H20H2Visible,
    divDiv0Div0Div0Nav0H20H2Renderer,
    divDiv0Div0Div0Nav0H20H2Props,
    divDiv0Div0Div0Nav0NavAriaLabel = "breadcrumb",
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkHref = "all_routes.home",
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkVisible,
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkRenderer,
    divDiv0Div0Div0Nav0Ol0Li0Link0LinkProps,
    divDiv0Div0Div0Nav0Ol0Li1LiText = "Pricing Plan",
    divDiv1ImageWithBasePath0ImageAlt = "img",
    divDiv1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/breadcrumb-bg-01.png",
    divDiv1ImageWithBasePath0ImageVisible,
    divDiv1ImageWithBasePath0ImageRenderer,
    divDiv1ImageWithBasePath0ImageProps,
    divDiv1ImageWithBasePath1ImageAlt = "img",
    divDiv1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/breadcrumb-bg-02.png",
    divDiv1ImageWithBasePath1ImageVisible,
    divDiv1ImageWithBasePath1ImageRenderer,
    divDiv1ImageWithBasePath1ImageProps,
    divDiv1ImageWithBasePath2ImageAlt = "img",
    divDiv1ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/breadcrumb-icon.png",
    divDiv1ImageWithBasePath2ImageVisible,
    divDiv1ImageWithBasePath2ImageRenderer,
    divDiv1ImageWithBasePath2ImageProps,
    divDiv1ImageWithBasePath3ImageAlt = "img",
    divDiv1ImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/breadcrumb-icon.png",
    divDiv1ImageWithBasePath3ImageVisible,
    divDiv1ImageWithBasePath3ImageRenderer,
    divDiv1ImageWithBasePath3ImageProps,
    divDiv0Div0ClassName,
}) => {
    return (
        <div className="breadcrumb-bar">
            <div className="container">
                <div className={divDiv0Div0ClassName ?? "row align-items-center inner-banner"}>
                    <div className="col-md-12 col-12 text-center">
                        <nav aria-label={divDiv0Div0Div0Nav0NavAriaLabel} className="page-breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    {renderNode(divDiv0Div0Div0Nav0Ol0Li0Link0LinkVisible, divDiv0Div0Div0Nav0Ol0Li0Link0LinkRenderer, (
                                        <SmartLink href={divDiv0Div0Div0Nav0Ol0Li0Link0LinkHref} {...(divDiv0Div0Div0Nav0Ol0Li0Link0LinkProps ?? {})}>
                                            <i className="isax isax-home-15" />
                                        </SmartLink>
                                    ))}
                                </li>
                                <li className="breadcrumb-item active">{divDiv0Div0Div0Nav0Ol0Li1LiText}</li>
                            </ol>
                            {renderNode(divDiv0Div0Div0Nav0H20H2Visible, divDiv0Div0Div0Nav0H20H2Renderer, (
                                <h2 className="breadcrumb-title" {...(divDiv0Div0Div0Nav0H20H2Props ?? {})}>{divDiv0Div0Div0Nav0H20H2Text}</h2>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
            <div className="breadcrumb-bg">
                {renderNode(divDiv1ImageWithBasePath0ImageVisible, divDiv1ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={divDiv1ImageWithBasePath0ImageSrc} alt={divDiv1ImageWithBasePath0ImageAlt} className="breadcrumb-bg-01" {...(divDiv1ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(divDiv1ImageWithBasePath1ImageVisible, divDiv1ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={divDiv1ImageWithBasePath1ImageSrc} alt={divDiv1ImageWithBasePath1ImageAlt} className="breadcrumb-bg-02" {...(divDiv1ImageWithBasePath1ImageProps ?? {})} />
                ))}
                {renderNode(divDiv1ImageWithBasePath2ImageVisible, divDiv1ImageWithBasePath2ImageRenderer, (
                    <SmartImage src={divDiv1ImageWithBasePath2ImageSrc} alt={divDiv1ImageWithBasePath2ImageAlt} className="breadcrumb-bg-03" {...(divDiv1ImageWithBasePath2ImageProps ?? {})} />
                ))}
                {renderNode(divDiv1ImageWithBasePath3ImageVisible, divDiv1ImageWithBasePath3ImageRenderer, (
                    <SmartImage src={divDiv1ImageWithBasePath3ImageSrc} alt={divDiv1ImageWithBasePath3ImageAlt} className="breadcrumb-bg-04" {...(divDiv1ImageWithBasePath3ImageProps ?? {})} />
                ))}
            </div>
        </div>
    );
};

export default BreadcrumbSectionGenerated;
